<template>
  <div class="RevisionTableComponent DataTables">

    <div v-show="isData" :id="id"></div>

    <LoaderComponent v-if="!isData"></LoaderComponent>

  </div>
</template>
<script>
  import LoaderComponent from "@/components/shared/LoaderComponent"
  import * as Tools from './../../Tools/Tools'

  import $ from 'jquery';
  import dt from 'datatables.net-bs4';

  export default {
    name: "RevisionTableComponent",
    props:{

      lang: Object
    },
    components: {
      LoaderComponent
    },
    data () {
        return {
          name: "RevisionTableComponent",
          mainTable: "",
          id: "revisionHistory"
        }
    },
    computed: {
      
      revisionHistory(){
        return this.$store.getters.revisionHistory;
      },

      isData(){
        
        return Object.keys(this.revisionHistory).length != 0
          
      },
      elementId(){
        
        return this.$route.query.id;
      },
      reloadedAfterActionComplex() {
        return this.$store.getters.reloadedAfterActionComplex;
      }
    },
    created() {
      this.reloadData();
    

    },
    watch: {
      elementId: function (newValue, old) {
        
        this.reloadData();
        
      },
      revisionHistory: {
        handler: function(newVal){
          
          if (newVal.length == 0) {
            let component = "DataTableFilteredOnApiComponent";
            if (this.$store.getters.sectionPrefix == "lm") {
              component = "DataTableFilteredOnApiLibComponent";
            }
            // if (this.$store.getters.sectionPrefix == "projm") {
            //   component = "DataTableFilteredOnApiProjComponent";
            // }

            const reloadObj = {
              status: true,
              name: component
            }
            this.$store.dispatch("reloadAfterActionComplex", reloadObj);

            let to = "/PartManager/PartTable";
            if (this.$store.getters.sectionPrefix == "lm") {
              to = "/LibraryManager/LibraryTable";
            }
            if (this.$store.getters.sectionPrefix == "projm") {
              to = "/ProjectManager/ProjectTable";
            }

            const query = {
              from: this.$route.path,
              to: to,

            }

            this.$router.push({ path: to, query: query });
          } else {

            this.buildTable();
          }
        },
        deep: true
      
        
      },
      
      reloadedAfterActionComplex: {
        handler: function (newValue) {

          for (let el in newValue) {

            if (newValue[el].name == this.name) {
              if (newValue[el].status == true) {

                this.reloadData();

                newValue[el].status = false;

                this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
              }
            }
          }
        },
        deep: true

      },
    },
    
    methods: {
      reloadData(){
        
        let vue = this;

        let value = this.$route.query.id;
        
        
        this.$store.dispatch(this.$store.getters.sectionPrefix + '_getRevisionHistory', value)
          .then((result) => {
            console.log(result)
            if (result.status == "OK") {

              if (result.data.length > 0) {
                let revisionId = result.data[result.data.length - 1].id;  
                
                vue.$router.push({ query: { ...vue.$route.query, revisionId: revisionId } });
              }
              
              
              
            }
            
        })
        
        
        

      },
      format(d) {
        let date = "";
        let date2 = "";
        if (d.date != null) {
          date = Tools.longDateToShort(d.date)
        }
        if (d.date2 != null) {
          date2 = Tools.longDateToShort(d.date2);
        }
        if (d.login == null) {
          d.login = "";
        }
        if (d.login2 == null) {
          d.login2 = "";
        }
        
        return '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px; width: 100%;">' +
          '<tr>' +
          '<td class="first-header">' + this.lang.table_header_RequestDate + ':</td>' +
          '<td class="second-header">' + Tools.longDateToShort(d.requestorDate) + '</td>' +
          '<td class="second-header">' + d.requestorName + '</td>' +
          '</tr>' +
          '<tr>' +
          '<td class="first-header">' + this.lang.table_header_Date1 + ':</td>' +
          '<td class="second-header">' + date + '</td>' +
          '<td class="second-header">' + d.login + '</td>' +
          '</tr>' +
          '<tr>' +
          '<td class="first-header">' + this.lang.table_header_Date2 + ':</td>' +
          '<td class="second-header">' + date2 + '</td>' +
          '<td class="second-header">' + d.login2 + '</td>' +
          '</tr>' +


          '</table>';
      },
      buildTable(){
        
        this.$store.dispatch("deselectAllRevisionRow")

        var tableplace = document.getElementById(this.id);
        if (tableplace == null) {
          return;
        }
        while (tableplace.firstChild) {
            tableplace.removeChild(tableplace.firstChild);
        }

        var table = document.createElement("table");
        table.setAttribute("id", "t_" + this.id);
        table.setAttribute("style", "width:100%");
        table.setAttribute("class", "table table-striped table-bordered");
        tableplace.appendChild(table)

        var tr = document.createElement("tr");
        tr.setAttribute("class", "cellHeader");
        var thead = document.createElement("thead");
        thead.appendChild(tr);
        table.appendChild(thead);

        var _vue = this;

        let columns = [
          {
            name: this.lang.table_header_Expand,
            alignInColumn: "left",
            type: "text",
            width: 50
          }, 
          {
            name: this.lang.table_header_Select,
            alignInColumn: "left",

          },
          {
            name: this.lang.table_header_Revision,
            alignInColumn: "left",

          },
          {
            name: this.lang.table_header_Status,
            alignInColumn: "left",
            dataObject: "1"
          },
          {
            name: this.lang.table_header_Date,
            alignInColumn: "left",

          },
          {
            name: this.lang.table_header_User,
            alignInColumn: "left",

          },
          {
            name: this.lang.table_header_RequestDate,
            alignInColumn: "left",

          },
          {
            name: this.lang.table_header_RequestName,
            alignInColumn: "left",

          },
          {
            name: this.lang.table_header_Date1,
            alignInColumn: "left",

          },
          {
            name: this.lang.table_header_Login1,
            alignInColumn: "left",

          },
          {
            name: this.lang.table_header_Date2,
            alignInColumn: "left",

          },
          {
            name: this.lang.table_header_Login2,
            alignInColumn: "left",

          },
        ]

        let cols = [
          {
            "className": 'details-control',
            "orderable": false,
            "data": null,
            "defaultContent": '<img src="/static/plus.svg">'
          },
          { "data": "id" },
          { "data": "revision" },
          { "data": "status" },
          { "data": "requestorDate" },
          { "data": "requestorName" },
          { "data": "requestorDate" },
          { "data": "requestorName" },
          { "data": "date" },
          { "data": "login" },
          { "data": "date2" },
          { "data": "login2" },
          


        ]
        let theHighestRev = {
          revisionId: 0,
          revision: 0,
          checked: false,
          login: ""
        };
        for (var j = 0, lej = this.revisionHistory.length; j < lej; j++){

          if (this.revisionHistory[j].revision > theHighestRev.revision){
            theHighestRev.revisionId = this.revisionHistory[j].id;
            theHighestRev.revision = this.revisionHistory[j].revision;
            theHighestRev.login = this.revisionHistory[j].login;

          }
        }
        this.$store.dispatch("setPartRevisionId", theHighestRev.revisionId);

        let columnDefs = [];
        var len = columns.length;
        for (var i = 0; i < len; i++){

          var el = {};

          var classname = '_dt-body-'+ columns[i].alignInColumn;

          el = {
            targets: i,
            className: classname,

            render: function ( data, type, row, meta ) {
              if (data == null) {
                data = "";
              }

              data = $.fn.dataTable.render.text().display(data);
              if (data.display != undefined) {
                data.display = $.fn.dataTable.render.text().display(data.display);
              }
              

                if(meta.col == 1){


                let  accepted = true;
                let checked = "";
                let disabled = "";

                if (theHighestRev.revisionId == row.id){
                  theHighestRev.checked = true;
                  checked = "checked";
                  if (_vue.revisionHistory.length == 1){
                    disabled = "disabled";
                  }
                  

                }

                row.login = $.fn.dataTable.render.text().display(row.login);

                let str = "<div class=\"custom-control custom-checkbox \"><input " + checked + " " + disabled + "  type=\"checkbox\" class=\"custom-control checkbox_type btn-primary\" id=\"selected_" + data + "_" + row.revision + "\" data-user=\""+row.login+"\" value=\""+ accepted +"\"></div>";

                  return str;
              } else if (meta.col == 2) { 
                
                  return data;
              }else if (meta.col == 3){

                let variant = Tools.getStatusColor(data.display);

                return "<b-badge class='badge badge-"+variant+" '>"+data.display+"</b-badge>"
              }else if (meta.col == 4) {
                
                if (row.date2 != null && row.date2 != "") {
                  
                  return Tools.longDateToShort(row.date2);
                }
                if (row.date != null && row.date != "") {
                  
                  return Tools.longDateToShort(row.date);
                }

                return Tools.longDateToShort(row.requestorDate);
                
              } else if (meta.col == 5) {
                
                if (row.login2 != null && row.login2 != "" && row.login2 != " ") {
                  
                  return row.login2;
                }
                
                if (row.login != null && row.login != "" && row.login != " ") {
                    
                  return row.login;
                }
                
                return row.requestorName;
                                  
                
              } else {
                
                return data;
              }




            }





          }

          columnDefs.push(el);


          var th = document.createElement("th");
          tr.appendChild(th);
          

          var br = document.createElement("br");
          th.appendChild(br);
          var tx = document.createTextNode(columns[i].name);
          th.appendChild(tx);


        }


        var json = {};
        json.paging = false;
        json.info = false;
        json.dom = 'f<t>';
        json.data = this.revisionHistory;
        json.myColumnFormats = columns;
        json.select = false;
        json.order = [[2, "desc"]];

        json.columns = cols;

        json.columnDefs = columnDefs;
        json.initComplete = function () {


          

        }
        
        this.$store.dispatch("selectRevisionRow", theHighestRev);


        if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
            this.mainTable.destroy();
            
        }

        var _vue = this;

        this.mainTable = $('#t_'+this.id).DataTable(json);

        this.mainTable.columns.adjust().draw();

        //hide first column in table
        this.mainTable.column(6).visible(false);
        this.mainTable.column(7).visible(false);
        this.mainTable.column(8).visible(false);
        this.mainTable.column(9).visible(false);
        this.mainTable.column(10).visible(false);
        this.mainTable.column(11).visible(false);

        //search input change view
        var searchplace = document.getElementById("t_"+this.id + "_filter").firstChild

        while (searchplace.firstChild) {

          if (searchplace.firstChild.textContent == "Search:"){
              searchplace.removeChild(searchplace.firstChild);
              break;
          }

        }
        searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
        searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

        $('#t_' + this.id + ' tbody').on('click', 'td.details-control', function (e) {


          var tr = $(this).closest('tr');
          var row = _vue.mainTable.row(tr);

          if (row.child.isShown()) {
            // This row is already open - close it
            e.target.src = "/static/plus.svg";
            row.child.hide();
            tr.removeClass('shown');
          }
          else {
            // Open this row
            e.target.src = "/static/minus.svg";
            row.child(_vue.format(row.data())).show();
            tr.addClass('shown');
          }
        });


        $(".checkboxtable").on("click", noclick);


        function noclick(e){

            e.stopPropagation();

        }

        $('#t_revisionHistory input[type="checkbox"]').click(function(e) {

          var s = e.target.id.split("_");
          

          let obj = {
            revisionId: parseInt(s[1]),
            checked: e.target.checked,
            revision: parseInt(s[2]),
            login: this.dataset.user
          }
          
          if (e.target.checked == true){
            _vue.$store.dispatch("selectRevisionRow", obj)
          }else{
            _vue.$store.dispatch("deselectRevisionRow", obj)
          }
          var arr = [];
          for (var i = 0, le = _vue.$store.getters.selectedRevisionRow.length; i < le; i++){
            if (_vue.$store.getters.selectedRevisionRow[i].checked == true){
              arr.push(_vue.$store.getters.selectedRevisionRow[i].key);
            }
          }



          

        })

        


      },
      selectRevisions(){
        
        for (var i = 0, le = this.revisionHistory.length; i < le; i++){
          
          if (this.revisionHistory[i][0].id == this.elementId){

            document.getElementById("n_" + this.revisionHistory[i][0].id).checked = true;
            
            this.$store.dispatch("selectRevisionRow", { revisionId: this.revisionHistory[i][0].id, checked: true})

          }
        }

        var arr = [];
        for (var i = 0, le = this.$store.getters.selectedRevisionRow.length; i < le; i++){
          if (this.$store.getters.selectedRevisionRow[i].checked == true){
            arr.push(this.$store.getters.selectedRevisionRow[i].id);
          }
        }

        
      }

    },
    


  }
</script>
<style lang="scss">
  .RevisionTableComponent{
    table{
      font-size: 0.75rem;
      padding: 0px !important;

    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .badge{
      margin-right: 1px;
      margin-top: 2px;
    }
        td.details-control {
    
          //background: url("/static/plus.svg") no-repeat center center;
          img {
            max-width: 30px;
            padding: 2px;
          }
    
        }
    
        tr.shown td.details-control {
          img {
            max-width: 30px;
            padding: 2px;
          }
    
          //background: url("/static/minus.svg") no-repeat center center;
        }
        .first-header {
          width: 20%;
        }

        .table {
          max-width: 380px;

        }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/RevisionTableComponent.vue